module.exports = __webpack_public_path__ + "img/sidebar-solar.6fc44a30.jpg";